import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesCategoryPiecesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesCategoryPiecesPages;
